import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { User } from '../models';

export const profileActions = createActionGroup({
    source: 'Profile',
    events: {
        // Get
        'Get Profile': emptyProps(),
        'Get Profile Success': props<{ payload: User }>(),
        'Get Profile Error': props<{ code: number }>(),
        // Language
        'Update Language': props<{ language: string }>(),
        'Update Language Success': props<{ payload: User }>(),
        'Update Language Error': props<{ code: number }>(),
        // Clear
        Clear: emptyProps(),
    },
});
